import type { Hazard, ValuesByYear, Year } from "@/features/pe_aldd";

export type AnomalyManagamentSupportedHazards = {
  coastal_inundation: number | null;
  cyclone_storm_surge: number | null;
  flood_riverine: number | null;
  flood_surfacewater: number | null;
};

export type DefenceSupportedHazards = {
  coastal_inundation: "defended" | "undefended";
  cyclone_storm_surge: "defended" | "undefended";
  flood_riverine: "defended" | "undefended";
  flood_surfacewater: "defended" | "undefended";
};

// Adapted from "get_top_two_hazards_for_year" in Facades.
export const getSignificantHazards = (byHazard: Record<Hazard, ValuesByYear>, year: Year): Hazard[] => {
  return Object.entries(byHazard)
    .filter(([, values]) => {
      const value = values[year];
      return value !== null && value >= 0.002;
    })
    .slice(0, 2)
    .map(([hazard]) => hazard as Hazard);
};
